import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackSearchItemPerPageChangedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackSearchItemPerPageChanged";
import { PartialSpecific } from "@store/Framework/Types/Common";

const useTrackSearchItemPerPageChanged = (
    parameters: PartialSpecific<TrackSearchItemPerPageChangedParameters, "item_per_page"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters = {
        ...ga.use.eventParameters(options),
        ...parameters,
    } as TrackSearchItemPerPageChangedParameters;

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        skipOptionItems: true,
        ...options,
    };

    return (parameters: TrackSearchItemPerPageChangedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.searchItemPerPageChanged({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackSearchItemPerPageChanged;
